<template>
<div height="100%" :class="bgImage()" v-if="showDialog">

<v-layout  align-center justify-center style="padding-top: 150px"> 
  <!-- <v-flex xs12 sm12 md12 lg12> -->
<v-card width="500px" >
  <v-card-title primary-title>
    <h3>Change or Set Password</h3>
  </v-card-title>
  <h5 v-if="tokenInvalid" width="40%" style="padding: 30px;">
    {{errMsg}}
  </h5>
  <div v-if="showForm" style="padding: 10px;">
    <ValidationObserver ref="observer" >
            <ValidationProvider
              name="password"
              ref="password1"
              rules="required|customPassword"
              v-slot="{ errors }"
              :bails="false"
            >
              <v-text-field
                prepend-icon="lock"
                v-model="password1"
                label="New Password"
                outlined
                autofocus
                counter
                :append-icon="show1 ? 'visibility' : 'visibility_off'"
                :type="show1 ? 'text' : 'password'"
                v-on:keyup.enter="submit"
                @click:append="show1 = !show1"
              ></v-text-field>
              <ul style="color: red" class="overline text-left">
                <li v-for="(error, index) in errors" :key="index">
                  <span>{{ error }}</span>
                </li>
              </ul>
            </ValidationProvider>
            <ValidationProvider
              name="password"
              ref="password2"
              rules="required|customPassword"
              v-slot="{ errors }"
              :bails="false"
            >
              <v-text-field
              
                prepend-icon="lock"
                class="mt-5"
                v-model="password2"
                :append-icon="show2 ? 'visibility' : 'visibility_off'"
                :type="show2 ? 'text' : 'password'"
                label="Confirm Password"
                counter
                @click:append="show2 = !show2"
                outlined
                v-on:keyup.enter="submit"
              ></v-text-field>
              <ul style="color: red" class="overline text-left">
                <li v-for="(error, index) in errors" :key="index">
                  <span>{{ error }}</span>
                </li>
              </ul>
            </ValidationProvider>
            <v-card-actions>
    <v-btn
      :disabled="!valid"
      @click="submit"
    >submit</v-btn>
    <v-btn @click="clear">clear</v-btn>
    <v-btn @click="cancel">cancel</v-btn>
    </v-card-actions>
          </ValidationObserver>
  <!-- <v-card-text >
    <v-text-field
      prepend-icon="lock"
      v-model="password"
      v-validate="{required: true, min: 8}"
      min="8"
      :error-messages="errors.collect('passwordInput')"
      name="passwordField"
      :type="'password'"
      label="New Password"
      data-vv-name="passwordInput"
      required
      autofocus
      v-on:keyup.enter="submit"
    ></v-text-field>
    <v-text-field
      prepend-icon="lock"
      v-model="confirmPassword"
      v-validate="{required: true, confirmed: password}"
      :error-messages="errors.collect('Password')"
      name="confirmPasswordField"
      data-vv-name="Password"
      :type="'password'"
      label="Confirm Password"
      required
      v-on:keyup.enter="submit"
    ></v-text-field>
    </v-card-text> -->

    
    </div>
  </v-card>
  <!-- </v-flex> -->
  </v-layout>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify'
import axiosInstances from '../server/axiosInstances'
import {ValidationProvider, extend} from "vee-validate/dist/vee-validate.full"
import { ValidationObserver } from "vee-validate/dist/vee-validate.full"
// import Login from '@/components/Login'
export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data: () => ({
    token: '',
    showForm: false,
    showDialog: true,
    password1: '',
    password2: '',
    // confirmPassword: '',
    tokenInvalid: false,
    errMsg: '',
    show1: false,
    show2: false,
  }),
  watch: {
    loginDialog (val) {
      if (val) this.$router.push('/Welcome')
    },
    loggedIn(val) {
      if (val) {
        if (this.loginActions) this.loginActions()
        // this.elog('log', 'Login succeded for {}', this.loggedinUser.email)()
      }
    }
  },
  computed: {
    loggedIn: sync('login/loggedIn'),
    loginDialog: sync('login/loginDialog'),
    loginActions: sync('login/loginActions'),
    valid () {
      return true
      return (!this.errors.any() && this.password1 && this.password2)
    }
  },
  methods: {
    bgImage () {
      var now = new Date()
      var hours = now.getHours()
      if (hours > 5 && hours <= 7) {
        return 'welcome-morning'
      } else if (hours > 7 && hours <= 16) {
        return 'welcome-day'
      } else if (hours > 16 && hours < 20) {
        return 'welcome-morning'
      } else {
        return 'welcome-night'
      }
    },
    submit () {
      var self = this
      // console.log('passwords: ', this.password1, this.password2)
      if (this.password1 == this.password2) {
        console.log('passwords match')
        this.changePassword (this.token, this.password1)
      } else {
        this.tokenInvalid = true
        self.errMsg = 'Passwords do not match'
        console.log('passwords do not match')
        setTimeout(function() {
          self.tokenInvalid = false
        }, 10000)
      }
    },
    clear () {
      this.password2 = ''
      this.password1 = ''
    },
    cancel () {
      this.$router.push('/')
    },
    async checkToken (token) {
      var self = this
      // console.log('checking token: ', token)
      try {
        await axiosInstances.loginServer.get('/auth/checkPWToken?token=' + token)
      } catch (ex) {
        // console.log(ex)
        self.tokenInvalid = true
        self.errMsg = "This link is invalid or has expired. Please request a new password reset link from the login page."
        return
      }
      self.showForm = true
    },
    async changePassword (token, password) {
      var self = this
      try {
        let rr = await axiosInstances.loginServer.get('/auth/changePassword?token=' + token + '&pw=' + password)
        if (rr.status == 200) {
          // console.log(rr)
          // let data = JSON.parse(rr.data)
          // console.log(data)
          // console.log(rr, rr.data.email, password)
          // await this.$store.dispatch('login/doLogin', {
          //   email: rr.data.email,
          //   password: password
          // })
          self.showDialog = true
					self.tokenInvalid = true
					let msg = 'Password changed. You can now use the new password to login to the Mobile App or Web Portal.'
					console.log(msg)
					self.errMsg = msg
          self.showForm = false
          // this.loginDialog = false
        }
      } catch (ex) {
        console.log(ex)
        self.tokenInvalid = true
        self.errMsg = "Unable to change password, possibly due to an expired link, please request a new link from login page."
        return
      }
      // this.loginDialog = true
      // this.$router.push('/Welcome')
    },
  },
  mounted () {
    this.menuList = []
  },
  mounted () {
    this.loginDialog = false
    this.token = this.$route.query.pwt
    // console.log(this.token)
    this.checkToken(this.token)
  },
  created () {
    this.loginDialog = false
  }
}
</script>

<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.welcome-morning {
  height: 100%;
  margin: 2px;
  background-size: cover;
  background-position: top;
  padding: 1rem;
  background-image: linear-gradient(to bottom, rgba(243, 55, 8, 0.301), rgba(4, 243, 36, 0.4)), url(../assets/background.jpg);
  /* -webkit-clip-path: polygon(0 0, 100% 0, 100% 90vh, 0 90vh); */
  clip-path: polygon(0 0, 100% 0, 100% 90vh, 0 90vh);
}
.welcome-day {
  height: 100%;
  margin: 2px;
  background-size: cover;
  background-position: top;
  padding: 1rem;
  background-image: url(../assets/background.jpg);
  -webkit-clip-path: polygon(0 0, 100% 0, 100% 90vh, 0 90vh);
  clip-path: polygon(0 0, 100% 0, 100% 90vh, 0 90vh);
}

.welcome-night {
  height: 100%;
  width: 100%;
  margin: 2px;
  background-size: cover;
  background-position: center;
  padding: 1rem;
  background-image: linear-gradient(to bottom, rgba(63, 60, 235, 0.7), rgba(166, 154, 218, 0.8)), url(../assets/background.jpg);
  -webkit-clip-path: polygon(0 0, 100% 0, 100% 90vh, 0 90vh);
  clip-path: polygon(0 0, 100% 0, 100% 90vh, 0 90vh);
}

#login {
  padding: 0px;
  margin: 0px;
}
</style>